<template>
  <List v-if="viewType === 'list'" />
  <Create v-else-if="viewType === 'new'" />
  <Detail v-else-if="viewType === 'detail'" />
  <Search v-else-if="viewType === 'search'" />
</template>

<script setup>
import { watch, ref } from "vue";
import { useRoute } from "vue-router";
import List from "./Apps/List.vue";
import Create from "./Apps/Create.vue";
import Detail from "@/Components/AppDetail/index.vue";
import Search from "./Apps/Search.vue";

const route = useRoute();

const viewType = ref("");
watch(
  () => route.query?.action,
  /**
   * @param {string?} action
   */
  (action) => {
    if (action === undefined) {
      viewType.value = "list";
    } else {
      viewType.value = action;
    }
  },
  { immediate: true }
);
</script>
